import http from '../jslibs/axios/http';

//合作咨询 获取列表
export  const getConsultList = data => (http.get('/v1/cms/Consultation', data))